import React from "react";
import CheckIcon from "../../assets/check.png";

export default function TopBanner() {
  return (
    <div className="bg-[#1D1726]">
      <div className="flex max-md:justify-center md:justify-start items-center gap-[48px] mx-auto max-md:px-[20px] max-w-[1160px] h-[48px]">
        <div className="flex justify-center items-center gap-[12px]">
          <img src={CheckIcon} className="w-[18px] h-[18px]" alt="check" />
          <p className="font-normal text-[#F5F5F5] text-[14px]">
            Geen dure advertenties.
          </p>
        </div>
        <div className="max-md:hidden flex justify-center items-center gap-[12px]">
          <img src={CheckIcon} className="w-[18px] h-[18px]" alt="check" />
          <p className="font-normal text-[#F5F5F5] text-[14px]">
            Geen influencer campagnes.
          </p>
        </div>
        <div className="max-md:hidden flex justify-center items-center gap-[12px]">
          <img src={CheckIcon} className="w-[18px] h-[18px]" alt="check" />
          <p className="font-normal text-[#F5F5F5] text-[14px]">
            Alleen echte aandacht en resultaten.
          </p>
        </div>
      </div>
    </div>
  );
}
